import { getDocumentId } from 'src/utils/mongo/getDocumentId';
import { IMessage } from 'src/interfaces/message';
import { IConversation } from 'src/interfaces/conversation';

/**
 * Verifies that a message belongs to the target conversation
 * using the populated Mongoose virtual `message.conversation._id`.
 */
export const messageBelongsToConversation = (
    message: IMessage,
    conversation: IConversation | string | null | undefined
): boolean => {
    const messageConversationId = getDocumentId(message?.conversation);
    const targetConversationId = getDocumentId(conversation);

    if (!messageConversationId || !targetConversationId) return false;

    return String(messageConversationId) === String(targetConversationId);
};
